export const siteUrl = 'https://hyperping.com';

export const organization = {
  '@type': 'Organization',
  name: 'Hyperping',
  url: siteUrl,
  logo: {
    '@type': 'ImageObject',
    url: 'https://hyperping.com/icons/icon-512x512.png'
  },
  sameAs: [
    'https://www.g2.com/products/hyperping/reviews',
    'https://www.capterra.com/p/181031/Hyperping/',
    'https://www.crunchbase.com/organization/hyperping',
    'https://x.com/hyperping',
  ]
};

export const author = {
  '@type': 'Person',
  name: 'Léo Baecker',
  sameAs: ['https://twitter.com/@sinequanonh']
};